export default __webpack_public_path__ + "static/media/legendary.e7ae7954.svg";